(function () {
  /* INT 2026-10-25 (Nils: ask again). Before the Automatic redirection fix on 25 Oct 13:50 a cold
     visitor from Denmark and elsewhere landed on the Germany/EUR backup, and some closed this card.
     That old note was permanent, so they were never asked again. v2 starts clean: anyone who closed the
     card before today can see it once more, but only when needsCard() finds a currency mismatch. Nobody
     is switched without a click. Closing it now writes v2, so a new close stays closed. */
  var KEY_DISMISSED = 'int_region_card_dismissed_v2';
  var KEY_SHOWN     = 'int_region_card_shown_session';
  function lsGet(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function lsSet(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
  function ssGet(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function ssSet(k,v){ try { sessionStorage.setItem(k,v); } catch(e){} }

  if (lsGet(KEY_DISMISSED)) return;
  if (ssGet(KEY_SHOWN)) return;

  var card = document.getElementById('int-region-card');
  if (!card) return;

  var sel = card.querySelector('[data-int-region-card-select]');
  var cta = card.querySelector('.int-region-card__cta');
  var ctaPrefix  = (cta && cta.getAttribute('data-cta-prefix')) || ((window.__intRegionI18n && window.__intRegionI18n.continueIn) || '');
  var defaultCur = (cta && cta.getAttribute('data-default-currency')) || '';
  var pendingCountry = '';

  var countryEl  = card.querySelector('[data-region-country]');
  var blurbEl    = card.querySelector('[data-region-blurb]');
  var shipEl       = card.querySelector('[data-region-ship]');
  var shipGroupEl  = card.querySelector('[data-region-ship-group]');
  /* Card-owned mounts. The global painter cannot match these. See the ownership
     comment in the markup above. */
  var mountApparel = card.querySelector('[data-int-freeship-card="apparel"]');
  var mountWallart = card.querySelector('[data-int-freeship-card="wallart"]');
  var blurbServed = card.getAttribute('data-blurb-served') || '';
  var blurbIntl   = card.getAttribute('data-blurb-intl') || '';

  /* INT 2026-10-19 (Nils: "the region card should only open as you say").
     Country to currency for every country we sell to, rendered by Liquid from
     localization.available_countries, so nothing here is typed by hand.
     Used by needsCard() below. */
  var CUR_BY_COUNTRY = {};
  (card.getAttribute('data-country-currencies') || '').split(',').forEach(function (p) {
    var kv = p.split(':');
    if (kv[0] && kv[1]) CUR_BY_COUNTRY[kv[0].toUpperCase()] = kv[1].toUpperCase();
  });

  /* Paint the card for a currency. A null name keeps the server heading. */
  function applyRegion(curr, name, intl){
    if (cta) cta.textContent = ctaPrefix + ' ' + curr;
    if (countryEl && name) countryEl.textContent = name;
    if (blurbEl) blurbEl.textContent = (intl ? blurbIntl : blurbServed).replace('{cur}', curr);
    if (shipGroupEl) {
      /* No numbers live in this file. int-shipping-thresholds.liquid owns them;
         we only pick the currency being previewed and decide visibility.
         MEASURED 2026-08-19 on the live storefront. Checkout shows TWO shipment
         lines (the profiles sit in separate location groups) and either can be
         free independently — but each threshold is tested against the WHOLE
         cart total, NET of discounts. So the apparel figure is not "over X of
         apparel", it is "on orders over X". Say it that way. */
      var T = window.__intShipThresholds;
      var known = !!(T && T.apparel && T.apparel[curr] != null);
      if (!intl && known && typeof window.__intFreeShipFrom === 'function') {
        if (mountApparel) mountApparel.textContent = window.__intFreeShipFrom(curr, false).text;
        if (mountWallart) mountWallart.textContent = window.__intFreeShipFrom(curr, true).text;
        shipGroupEl.hidden = false;
      } else {
        shipGroupEl.hidden = true;
      }
    }
  }
  applyRegion(defaultCur, null, false);

  /* Timezone-based market inference for cold visitors on the backup region.
     Shopify serves the Germany / EUR backup to every visitor it has not
     placed in a market, so a Danish, Nordic, Polish, Swiss or UK visitor
     lands on EUR. The device timezone, which a VPN does not change, tells us
     their real market. If its currency differs from the active one, relabel
     the card to that market and remember it as the switch target. Visitors
     already on their local currency, and European visitors on EUR, are left
     untouched. */
  var TZ_TO_COUNTRY = {
    'Europe/Copenhagen':'DK','Europe/Stockholm':'SE','Europe/Oslo':'NO',
    'Europe/Warsaw':'PL','Europe/Zurich':'CH','Europe/Busingen':'CH','Europe/London':'GB'
  };
  var tzTarget = '';
  try {
    var tz = (window.Intl && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : '';
    var tzCountry = TZ_TO_COUNTRY[tz] || '';
    var activeCur0 = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : defaultCur;
    if (tzCountry && sel) {
      var tzOpt = sel.querySelector('option[value="' + tzCountry + '"]');
      var tzCur = tzOpt ? (tzOpt.getAttribute('data-currency') || '') : '';
      if (tzCur && tzCur !== activeCur0) {
        tzTarget = tzCountry;
        applyRegion(tzCur, tzOpt.text.replace(/\s*\([^)]*\)\s*$/, '').trim(), false);
      }
    }
  } catch(e){}

  /* ====================================================
     OUT OF MARKET (INT 2026-09-03)
     If snippets/int-out-of-market.liquid resolves a country that is not in the
     derived market list, this card is the first of the two surfaces that say
     so. It REPLACES the reassurance text, because "Shipping to Denmark, free
     shipping over 1,000 DKK" is actively misleading to a visitor in Australia.
     Nothing here blocks anything: the selector and the button keep working, so
     the visitor can still switch to a country we do serve.
     Every failure path in that snippet resolves to null, and null means this
     runs not at all and the card paints exactly as it always did.
     ==================================================== */
  var oomEl      = card.querySelector('[data-region-oom]');
  var eyebrowEl  = card.querySelector('[data-region-eyebrow]');
  var eyebrowWas = eyebrowEl ? eyebrowEl.textContent : '';
  var oomActive  = false;

  function paintOOM(v) {
    if (!v || !window.__intOOM) return;
    oomActive = true;
    var copy = window.__intOOM.copy || {};
    if (eyebrowEl && copy.eyebrow) eyebrowEl.textContent = copy.eyebrow;
    if (countryEl) countryEl.textContent = v.name;
    if (blurbEl) blurbEl.hidden = true;
    if (oomEl) { oomEl.innerHTML = window.__intOOM.noticeHtml(v.name); oomEl.hidden = false; }
    if (shipGroupEl) shipGroupEl.hidden = true;
    if (cta && copy['continue']) cta.textContent = copy['continue'];
  }

  /* Picking a served country turns the card back into the normal one. */
  function clearOOM() {
    if (!oomActive) return;
    oomActive = false;
    if (eyebrowEl) eyebrowEl.textContent = eyebrowWas;
    if (oomEl) { oomEl.hidden = true; oomEl.innerHTML = ''; }
    if (blurbEl) blurbEl.hidden = false;
  }

  /* Hold the reveal until the country is known, capped, because a card that
     paints "Shipping to Denmark" and then rewrites itself is worse than one
     that arrives a beat later. If it has not resolved by the cap we show the
     ordinary card, which is the correct silent fallback. */
  /* INT 2026-10-19. Open the card ONLY when it has something to say:
     (1) the visitor is in a country we do not ship to (paintOOM above), or
     (2) the country Shopify detects for the visitor (int_oom_v1, written by
         int-out-of-market.js from /browsing_context_suggestions.json) prices in
         a different currency than the one the page shows, e.g. a Danish visitor
         who landed on the EUR backup, or
     (3) detection failed and the device timezone points to such a market.
     A visitor already shown their own currency never sees it. Cold ad traffic
     from Spain, Greece or Germany on EUR is no longer interrupted. */
  function detectedCountry() {
    try {
      var o = JSON.parse(ssGet('int_oom_v1') || 'null');
      return (o && o.c) ? String(o.c).toUpperCase() : '';
    } catch (e) { return ''; }
  }
  function needsCard() {
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : defaultCur;
    var code = detectedCountry();
    if (code) {
      var want = CUR_BY_COUNTRY[code];
      if (!want) return true;
      if (want === active) return false;
      var opt = sel ? sel.querySelector('option[value="' + code + '"]') : null;
      if (opt) {
        tzTarget = code;
        applyRegion(want, opt.text.replace(/\s*\([^)]*\)\s*$/, '').trim(), false);
      }
      return true;
    }
    return !!tzTarget;
  }

  function revealWhenKnown() {
    var done = false;
    function go(v) {
      if (done) return; done = true;
      if (v) { paintOOM(v); reveal(); return; }
      if (needsCard()) reveal();
      else ssSet(KEY_SHOWN, '1');
    }
    var t = setTimeout(function () { go(null); }, 6000);
    var p = window.__intOOM && window.__intOOM.ready;
    if (p && typeof p.then === 'function') {
      p.then(function (v) { clearTimeout(t); go(v); }, function () { clearTimeout(t); go(null); });
    }
  }

  function dismiss() {
    lsSet(KEY_DISMISSED, '1');
    card.classList.remove('is-visible');
    card.setAttribute('aria-hidden', 'true');
    setTimeout(function(){ card.hidden = true; card.style.display = ''; }, 320);  /* clear the inline display so it returns to display:none after the exit */
  }
  function reveal() {
    card.hidden = false;
    card.style.display = 'block';   /* render now, at the hidden transform, so the transition has a start state */
    void card.offsetWidth;          /* force one reflow to capture that start before is-visible flips the transform */
    requestAnimationFrame(function(){
      card.classList.add('is-visible');
      card.setAttribute('aria-hidden', 'false');
    });
    ssSet(KEY_SHOWN, '1');
  }

  /* Choosing a country previews that region across the card, no switch yet. */
  if (sel) sel.addEventListener('change', function(){
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var curr = opt.getAttribute('data-currency') || defaultCur;
    var name = opt.text.replace(/\s*\([^)]*\)\s*$/, '').trim();
    pendingCountry = sel.value || '';
    clearOOM();
    applyRegion(curr, name, false);
  });

  /* Button commits. If a country was chosen, drive the existing header
     selector to do the real market and language switch, so there is no
     duplicated switch logic. If nothing was chosen, accept the default. */
  function confirmRegion(){
    var detected = tzTarget || (window.Shopify && Shopify.country) || card.getAttribute('data-current-country') || '';
    var target   = pendingCountry || detected;
    var curLang  = (window.Weglot && typeof Weglot.getCurrentLang === 'function') ? Weglot.getCurrentLang() : 'en';
    var tgtLang  = (typeof window.__intLangForCountry === 'function') ? window.__intLangForCountry(target) : 'en';

    /* Local currency for the target country, read off the selector's own
       option, vs the active cart currency. Shopify still resolves the country
       server-side, but since the native geolocation app was retired it no
       longer switches currency on a cold visit, so a Danish visitor can sit
       on the EUR primary while the region still reads DK. A currency mismatch
       is a reason to switch, not to dismiss. */
    var tgtOpt    = sel ? sel.querySelector('option[value="' + target + '"]') : null;
    var wantCur   = (tgtOpt && tgtOpt.getAttribute('data-currency')) || defaultCur;
    var activeCur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
    var curMatches = !activeCur || !wantCur || activeCur === wantCur;

    lsSet(KEY_DISMISSED, '1');

    /* Accepted the detected region, the language already matches, and the
       active currency already equals the local one: nothing to switch, just
       close. Otherwise drive the live header selector, which sets currency if
       needed and navigates to the language path. */
    if (!pendingCountry && tgtLang === curLang && curMatches) { dismiss(); return; }

    if (cta) cta.classList.add('is-loading');

    var live = document.querySelector('[data-int-region-select]');
    if (live && target) {
      try {
        live.value = target;
        live.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      } catch(e){}
    }
    try {
      sessionStorage.setItem('int_currency_override','1');
      var form = sel && sel.closest('form');
      if (form) {
        if (!form.querySelector('[name="authenticity_token"]')) {
          var tok = document.querySelector('meta[name="csrf-token"]');
          if (tok) { var h = document.createElement('input'); h.type='hidden'; h.name='authenticity_token'; h.value = tok.getAttribute('content'); form.appendChild(h); }
        }
        form.submit();
        return;
      }
    } catch(e){}
    window.location.reload();
  }
  if (cta) cta.addEventListener('click', confirmRegion);
  window.__intRegionCardDismiss = dismiss;

  card.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-region-card-dismiss]')) dismiss();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && card.classList.contains('is-visible')) dismiss();
  });

  /* A beat after consent is decided before the card arrives, so it does not
     land in the spot the cookie banner just left. The pause covers the
     banner's own dismiss animation plus a little breathing room, then reveals
     on idle as before. Tune the 650 if you want more or less of a gap. */
  function schedule(){
    setTimeout(function(){
      if ('requestIdleCallback' in window) requestIdleCallback(revealWhenKnown, { timeout: 1000 });
      else setTimeout(revealWhenKnown, 600);
    }, 650);
  }

  /* Hold the card until the visitor has answered the Pandectes cookie banner.
     The banner is a <dialog> inside the shadow root on the <pandectes-cmp>
     host, not a light-DOM element, and on this store it forwards nothing to
     Shopify's consent API, so gate on the two signals that do work: the shadow
     dialog's presence, and the _pandectes_gdpr cookie written on accept or
     decline. Accept does not reload the page, so this just reveals in place
     the moment the choice is made. */
  function scheduleGated(){
    var done = false;
    var poll, safety;
    function cleanup(){ clearInterval(poll); clearTimeout(safety); }
    function go(){ if (done) return; done = true; cleanup(); schedule(); }

    /* Bonus signal if Pandectes ever starts forwarding consent to Shopify. */
    document.addEventListener('visitorConsentCollected', go, { once: true });

    /* Ground truth: Pandectes writes this cookie when a choice is made. */
    function consentDecided(){
      return /(?:^|;)\s*_pandectes_gdpr=/.test(document.cookie);
    }

    /* The banner dialog lives in the shadow root and is removed once answered;
       querySelector cannot pierce it, so reach through the host's shadowRoot. */
    function bannerUp(){
      var host = document.querySelector('pandectes-cmp');
      return !!(host && host.shadowRoot && host.shadowRoot.querySelector('dialog'));
    }

    var sawBanner = false, goneSince = 0, ticks = 0;
    var CLOSE_GRACE = 600; /* ms the dialog must stay gone before we treat it as closed, long enough to ride out the banner-to-preferences swap */
    poll = setInterval(function(){
      ticks++;
      if (consentDecided()) return go();          /* accepted, declined, or saved preferences */
      if (bannerUp()) { sawBanner = true; goneSince = 0; return; }  /* a CMP dialog is open: banner or preferences, so hold */
      if (sawBanner) {                            /* a dialog was up and is now gone: a real close (X), or just the swap gap */
        if (!goneSince) { goneSince = Date.now(); return; }
        if (Date.now() - goneSince >= CLOSE_GRACE) return go();     /* stayed gone past the grace, no new dialog, no cookie, so treat as closed */
        return;
      }
      if (document.querySelector('pandectes-cmp')) return; /* host present, first dialog still pending, so hold */
      if (ticks >= 20) return go();               /* ~3s: CMP never appeared */
    }, 150);

    /* Backstop so the card is never lost, but it must not fire on top of an
       open Pandectes panel. While the banner is being ignored or the
       preferences panel is still up, recheck instead of dropping the card in.
       Forces through after about 30s no matter what. */
    var safetyTries = 0;
    function armSafety(){
      safety = setTimeout(function(){
        if (consentDecided() || !document.querySelector('pandectes-cmp')) return go();
        if (++safetyTries < 6) return armSafety();
        return go();
      }, 5000);
    }
    armSafety();
  }
  function start(){ scheduleGated(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
